/* ============================================================
   Vídeo: autoplay na PDP (galeria) + cards (segunda mídia)
   + modal para abrir sem crop ao clicar (PDP)
   Versão simplificada para garantir autoplay nos CARDS
   ============================================================ */

(function () {
  // ======= Seletores (ajuste se seu tema usar outros) =======
  const SELECTOR_GALERIA = '.product-gallery, .media-gallery, product-media, .product__media-list';
  const CARD_SEL = '.product-card, .product-card__figure, .card--product';
  const CARD_MEDIA_AREA = '.product-card__figure, .product-card, .card--product';
  const ACTIVE_CLASS_HINTS = ['is-active', 'is-selected', 'swiper-slide-active'];

  // ======= Helpers =======
  function prepVideo(el, { muted = true, loop = true, preload = 'metadata' } = {}) {
    if (!el) return;
    if (muted) { el.setAttribute('muted', ''); el.muted = true; }
    el.setAttribute('playsinline', '');
    if (loop) el.setAttribute('loop', '');
    el.setAttribute('preload', preload);
  }

  function isActiveSlide(node) {
    if (!node) return false;
    return (
      ACTIVE_CLASS_HINTS.some(cls => node.classList.contains(cls)) ||
      node.closest('.is-active') || node.closest('.is-selected') || node.closest('.swiper-slide-active')
    );
  }

  function isYouTube(iframe){ return !!iframe?.src?.includes('youtube'); }
  function isVimeo(iframe){ return !!iframe?.src?.includes('vimeo'); }

  function extractYTId(urlStr){
    try {
      const u = new URL(urlStr, location.href);
      if (u.searchParams.get('v')) return u.searchParams.get('v');
      const m = u.pathname.match(/\/embed\/([A-Za-z0-9_-]+)/);
      return m ? m[1] : null;
    } catch(e){ return null; }
  }

  function ensureQuery(src, params) {
    try {
      const u = new URL(src, window.location.href);
      Object.entries(params).forEach(([k,v]) => u.searchParams.set(k, v));
      return u.toString();
    } catch(e) { return src; }
  }

  function playExternal(iframe) {
    if (!iframe) return;
    iframe.src = ensureQuery(iframe.src,
      isYouTube(iframe)
        ? { autoplay: '1', mute: '1', controls: '0', playsinline: '1', rel: '0', loop: '1', playlist: extractYTId(iframe.src) || '' , enablejsapi:'1'}
        : isVimeo(iframe)
        ? { autoplay: '1', muted: '1', loop: '1', background: '1', api:'1' }
        : { autoplay: '1' }
    );
    try {
      if (isYouTube(iframe)) iframe.contentWindow?.postMessage(JSON.stringify({ event:'command', func:'playVideo', args:[] }), '*');
      if (isVimeo(iframe)) iframe.contentWindow?.postMessage({ method:'play' }, '*');
    } catch(e){}
  }

  function pauseExternal(iframe) {
    try {
      if (isYouTube(iframe)) iframe.contentWindow?.postMessage(JSON.stringify({ event:'command', func:'pauseVideo', args:[] }), '*');
      if (isVimeo(iframe)) iframe.contentWindow?.postMessage({ method:'pause' }, '*');
    } catch(e){}
  }

  // ======= PDP: autoplay por visibilidade + slide ativo =======
  const ioPDP = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const container = entry.target;
      const video = container.querySelector('video');
      const iframe = container.querySelector('iframe');

      if (entry.isIntersecting && isActiveSlide(container)) {
        if (video) video.play().catch(()=>{});
        if (iframe) playExternal(iframe);
      } else {
        if (video) video.pause();
        if (iframe) pauseExternal(iframe);
      }
    });
  }, { threshold: 0.25 });

  function hookProductGallery(root) {
    if (!root) return;
    const items = root.querySelectorAll('[data-media-id], .product__media-item, .media-gallery__media, li, .swiper-slide');
    items.forEach(item => {
      const v = item.querySelector('video');
      if (v) prepVideo(v); // muted/inline para autoplay seguro
      ioPDP.observe(item);
    });

    ['slideChanged', 'product:media:change'].forEach(evt => {
      root.addEventListener(evt, () => {
        items.forEach(item => {
          const v = item.querySelector('video');
          const f = item.querySelector('iframe');
          const active = isActiveSlide(item) && item.getBoundingClientRect().top < window.innerHeight;
          if (v) active ? v.play().catch(()=>{}) : v.pause();
          if (f) active ? playExternal(f) : pauseExternal(f);
        });
      });
    });
  }

  // ======= CARDS (versão simplificada e robusta) =======
  // Regras:
  // - No hover (ou foco por teclado) do bloco de mídia do card, tocar QUALQUER <video> ou <iframe> dentro.
  // - Ao sair do hover/foco, pausar.
  // - Em offscreen, pausar.
  function setupCard(card) {
    const area = card.matches(CARD_MEDIA_AREA) ? card : card.querySelector(CARD_MEDIA_AREA) || card;

    function getMediaNodes() {
      // Se a 2ª mídia existir (secondary/hover), preferimos ela; senão pegamos qualquer vídeo do card
      const secondary = area.querySelector('.product-card__image--secondary, .product-card__image--hover, .card__media--hover, .media--hover, [data-media-position="2"]');
      const scope = secondary || area;
      const vids = Array.from(scope.querySelectorAll('video'));
      const ifr = Array.from(scope.querySelectorAll('iframe'));
      return { vids, ifr };
    }

    function playAll() {
      const { vids, ifr } = getMediaNodes();
      vids.forEach(v => { prepVideo(v, { muted:true, loop:true, preload:'auto' }); v.play().catch(()=>{}); });
      ifr.forEach(f => playExternal(f));
    }

    function pauseAll() {
      const { vids, ifr } = getMediaNodes();
      vids.forEach(v => v.pause());
      ifr.forEach(f => pauseExternal(f));
    }

    // hover/foco
    ['mouseenter','focusin'].forEach(evt => area.addEventListener(evt, playAll));
    ['mouseleave','focusout'].forEach(evt => area.addEventListener(evt, pauseAll));

    // offscreen
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => { if (!en.isIntersecting) pauseAll(); });
    }, { threshold: 0.1 });
    io.observe(area);
  }

  // ======= Modal (PDP) ao clicar, sem crop, com som/controles =======
  function ensureLightbox() {
    let overlay = document.querySelector('.video-lightbox-overlay');
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.className = 'video-lightbox-overlay';
    overlay.innerHTML = `
      <div class="video-lightbox" role="dialog" aria-modal="true" aria-label="Video player">
        <button class="video-lightbox__close" aria-label="Fechar">×</button>
        <div class="video-lightbox__stage"></div>
      </div>
    `;
    document.body.appendChild(overlay);

    overlay.addEventListener('click', (e) => {
      const isBg = e.target.classList.contains('video-lightbox-overlay');
      const isClose = e.target.classList.contains('video-lightbox__close');
      if (isBg || isClose) closeLightbox(overlay);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeLightbox(overlay);
      }
    });

    return overlay;
  }

  function closeLightbox(overlay){
    const stage = overlay.querySelector('.video-lightbox__stage');
    const v = stage.querySelector('video');
    if (v) { v.pause(); }
    stage.innerHTML = '';
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function openWithNativeVideo(srcOrEl) {
    const overlay = ensureLightbox();
    const stage = overlay.querySelector('.video-lightbox__stage');
    stage.innerHTML = '';

    let videoEl;
    if (srcOrEl instanceof HTMLVideoElement) {
      videoEl = srcOrEl.cloneNode(true);
      if (!videoEl.src) {
        const source = srcOrEl.querySelector('source');
        if (source) videoEl.src = source.src;
      }
    } else {
      videoEl = document.createElement('video');
      videoEl.src = srcOrEl;
    }

    videoEl.removeAttribute('muted');
    videoEl.muted = false;
    videoEl.setAttribute('controls', '');
    videoEl.setAttribute('playsinline', '');
    videoEl.setAttribute('preload', 'auto');
    videoEl.autoplay = true;

    stage.appendChild(videoEl);
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';

    setTimeout(()=> videoEl.play().catch(()=>{}), 50);
  }

  function ytOrVimeoUrlWithControls(src){
    try {
      const u = new URL(src, location.href);
      if (u.host.includes('youtube')) {
        u.searchParams.set('autoplay','1');
        u.searchParams.set('mute','0');
        u.searchParams.set('controls','1');
        u.searchParams.set('playsinline','1');
        u.searchParams.set('rel','0');
      } else if (u.host.includes('vimeo')) {
        u.searchParams.set('autoplay','1');
        u.searchParams.set('muted','0');
        u.searchParams.set('loop','0');
        u.searchParams.set('title','0');
        u.searchParams.set('byline','0');
        u.searchParams.set('portrait','0');
      } else {
        u.searchParams.set('autoplay','1');
      }
      return u.toString();
    } catch(e) {
      return src;
    }
  }

  function openWithIframe(srcOrEl){
    const overlay = ensureLightbox();
    const stage = overlay.querySelector('.video-lightbox__stage');
    stage.innerHTML = '';

    const iframe = document.createElement('iframe');
    iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    iframe.setAttribute('frameborder', '0');
    iframe.src = ytOrVimeoUrlWithControls(
      srcOrEl instanceof HTMLIFrameElement ? srcOrEl.src : srcOrEl
    );

    stage.appendChild(iframe);
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function attachClicksToPDP() {
    const root = document.querySelector(SELECTOR_GALERIA);
    if (!root) return;

    root.addEventListener('click', (e) => {
      const video = e.target.closest('video');
      const iframe = e.target.closest('iframe');
      if (!video && !iframe) return;

      e.stopPropagation();
      e.preventDefault();

      if (video) openWithNativeVideo(video);
      if (iframe) openWithIframe(iframe);
    }, true);
  }

  // ======= Init =======
  document.addEventListener('DOMContentLoaded', () => {
    // PDP
    document.querySelectorAll(SELECTOR_GALERIA).forEach(hookProductGallery);
    attachClicksToPDP();

    // Cards (robusto/simplificado)
    document.querySelectorAll(CARD_SEL).forEach(setupCard);
  });
})();